  <ion-header class="ion-no-border ion-no-margin">
    <ion-toolbar class="ion-no-padding ion-no-margin">
      <ion-buttons slot="secondary">
        <ion-button fill="clear" (click)="dismissEvent()">
          <ion-icon size="large" color="light" slot="icon-only"  name="close-circle"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
